import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { NavigationExtras, Router } from '@angular/router';
import {
  LoadingController,
  MenuController,
  NavController,
} from '@ionic/angular';
import {
  APP_CONFIG,
  AUTH_USER_CODE,
  URL_FILE,
} from 'src/app/interfaces/constants';
import { AppService } from 'src/app/services/app.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CalendarService } from 'src/app/services/calendar.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {
  config: any;
  logged = false;
  freePhoneNumber: string;
  freePhoneNumberTrimed: string;
  country: string;
  user: string;
  link: string;
  calendarJson: any;
  calendarButton = false;
  hasAB = false;

  constructor(
    private authService: AuthenticationService,
    private appService: AppService,
    public loadingCtrl: LoadingController,
    private menuCtrl: MenuController,
    private router: Router,
    private sanitizer: DomSanitizer,
    private navCtrl: NavController,
    private calendarService: CalendarService
  ) {}

  ngOnInit() {
    this.authService.menuNotifier.subscribe((menu) => {
      if (menu) {
        this.logged = true;
        this.config = this.appService.getLocalConfig().companyInfo;
        this.freePhoneNumber = this.config.companyPhoneNumberFree;
        this.freePhoneNumberTrimed = this.freePhoneNumber?.replace(/\s/g, '');
        this.country = this.config.countryInfo.code;
        if (
          JSON.parse(localStorage.getItem(AUTH_USER_CODE)).hasAB !== null &&
          JSON.parse(localStorage.getItem(AUTH_USER_CODE)).hasAB !== undefined
        ) {
          this.hasAB = JSON.parse(localStorage.getItem(AUTH_USER_CODE)).hasAB;
          this.user = JSON.parse(localStorage.getItem(AUTH_USER_CODE)).username;
          this.calendarService.getData().subscribe((res: any) => {
            this.calendarJson = res;
            this.checkForCalendar();
          });
        }
      }
    });
  }

  redirect() {
    this.menuCtrl.close();
    this.router.navigateByUrl('tabs/tab2');
  }
  gotoPost() {
    this.menuCtrl.close();
    this.router.navigateByUrl('tabs/tab1/posts/all');
  }
  gotoNotes() {
    this.menuCtrl.close();
    this.router.navigateByUrl('/tabs/tab1/post-type/0/2');
  }
  gotoVideos() {
    this.menuCtrl.close();
    this.router.navigateByUrl('/tabs/tab1/post-type/0/3');
  }
  gotoPodcast() {
    this.menuCtrl.close();
    this.router.navigateByUrl('/tabs/tab1/post-type/0/1');
  }
  gotoTest() {
    this.menuCtrl.close();
    this.router.navigateByUrl('tabs/tab1/tests');
  }
  gotoBenefit() {
    this.menuCtrl.close();
    this.router.navigateByUrl('tabs/tab1/beneficio');
  }
  gotoConsult() {
    this.menuCtrl.close();
    this.router.navigateByUrl('tabs/tab1/consult');
  }
  goToAB() {
    this.menuCtrl.close();
    this.router.navigateByUrl('tabs/tab1/videos');
  }
  gotoCategories() {
    this.menuCtrl.close();
    const currentUrl = this.router.url;
    if (currentUrl !== '/tabs/tab1') {
      this.navCtrl.navigateForward('/tabs/tab1').then(() => {
        this.scrollDown();
      });
    } else {
      this.scrollDown();
    }
  }
  scrollDown() {
    const element = document.getElementById('category-content');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    }
  }
  logout() {
    this.menuCtrl.close();
    this.authService.logout();
    this.router.navigateByUrl('/');
    location.reload();
  }
  getSanitizedImage(config: any): SafeStyle {
    if (config.logoData !== undefined) {
      return this.sanitizer.bypassSecurityTrustStyle(
        `url('${config.logoData}')`
      );
    }
  }
  goToCalendar() {
    window.open(this.link, '_blank');
  }
  checkForCalendar() {
    const companies = this.calendarJson.map((e) => e.nombre);
    if (this.user && this.user !== undefined) {
      const i = companies.indexOf(this.user.toLowerCase());
      if (i === -1) {
        this.calendarButton = false;
      } else {
        const companyCountries = this.calendarJson[i].countryCodes;
        if (companyCountries && companyCountries !== undefined) {
          const ci = companyCountries.indexOf(this.country);
          if (ci !== -1) {
            this.calendarButton = true;
            this.link = this.calendarJson[i].link;
          } else {
            this.calendarButton = false;
          }
        }
      }
    }
  }
}
